import React, { Component } from 'react'
import '../css/NewsItem.css'

class NewsItem extends Component {
    openInNewTab(url) {
        var win = window.open(url, '_blank');
        if (win != null) {
            win.focus();
        }
    }

    render() {
        const lang = this.props.lang || 'zh';
        const readMoreText = {
            zh: '閱讀全文',
            en: 'Read More',
            ja: '続きを読む'
        };
        const headerText = {
            zh: '媒體報導',
            en: 'Media Coverage',
            ja: 'メディア掲載'
        };

        const items = this.props.content || [];
        const featured = items[0];
        const rest = items.slice(1);

        return (
            <div className="media-page">
                <div className="media-page__hero">
                    <h1>{headerText[lang]}</h1>
                </div>

                {featured && (
                    <article
                        className="media-featured"
                        onClick={() => this.openInNewTab(featured["url"] === "PDF" ? `${process.env.PUBLIC_URL}/assets/pdf/news1.pdf` : featured["url"])}
                    >
                        <div
                            className="media-featured__image"
                            style={{
                                backgroundImage: `url(${process.env.PUBLIC_URL + "/image/" + featured["img"]})`,
                                ...(featured["imgPosition"] ? {backgroundPosition: featured["imgPosition"]} : {})
                            }}
                        >
                            <div className="media-featured__image-overlay" />
                        </div>
                        <div className="media-featured__body">
                            <span className="media-featured__source">{featured["date"]}</span>
                            <h3 className="media-featured__title">{featured["desc"]}</h3>
                            <span className="media-featured__tag">{featured["title"]}</span>
                            <span className="media-featured__cta">{readMoreText[lang]} &rarr;</span>
                        </div>
                    </article>
                )}

                <div className="media-grid">
                    {rest.map((item, index) => (
                        <article
                            key={index}
                            className="media-card"
                            onClick={() => this.openInNewTab(item["url"] === "PDF" ? `${process.env.PUBLIC_URL}/assets/pdf/news1.pdf` : item["url"])}
                            style={{ animationDelay: `${index * 0.08}s` }}
                        >
                            <div className="media-card__image-wrap">
                                <div
                                    className="media-card__image"
                                    style={{backgroundImage: `url(${process.env.PUBLIC_URL + "/image/" + item["img"]})`}}
                                />
                            </div>
                            <div className="media-card__body">
                                <span className="media-card__source">{item["date"]}</span>
                                <h4 className="media-card__title">{item["desc"]}</h4>
                                <div className="media-card__footer">
                                    <span className="media-card__tag">{item["title"]}</span>
                                    <span className="media-card__cta">{readMoreText[lang]} &rarr;</span>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        );
    }
}

export default NewsItem;
